<template>
  <v-app>
    <transition name="fade">
      <div id="main-wrap" class="page-fade-transition-exit global-brand-bg">
        <v-main>
          <nuxt />
        </v-main>
      </div>
    </transition>
  </v-app>
</template>

<script>
export default {
  head() {
    const baseUrl = "https://www.motanamy.com";
    const currentPath = this.$route.path;
    const currentLocale = this.$i18n.locale;
    const localeCodes = this.$i18n.locales.map(locale => locale.code);
    const localePrefixRegex = new RegExp(`^/(${localeCodes.join("|")})(?=/|$)`);
    const pathWithoutLocale = this.$route.path.replace(localePrefixRegex, "") || "/";
    
    // Build alternate links for all languages
    const alternateLinks = [
      {
        rel: "canonical",
        href: `${baseUrl}${currentPath}`,
      }
    ];

    // Add hreflang for each language
    this.$i18n.locales.forEach(locale => {
      const localePath = `/${locale.code}${pathWithoutLocale === "/" ? "" : pathWithoutLocale}`;
      alternateLinks.push({
        rel: "alternate",
        hreflang: locale.iso,
        href: `${baseUrl}${localePath}`
      });
    });

    // Add x-default hreflang pointing to Arabic (your default)
    alternateLinks.push({
      rel: "alternate",
      hreflang: "x-default",
      href: `${baseUrl}/ar${pathWithoutLocale === "/" ? "" : pathWithoutLocale}`
    });

    const organizationSchema = {
      "@context": "https://schema.org",
      "@type": "Organization",
      "name": "Motanamy",
      "url": baseUrl,
      "logo": `${baseUrl}/favicons/android-chrome-512x512.png`,
      "sameAs": ["https://developers.motanamy.com/"],
      "contactPoint": {
        "@type": "ContactPoint",
        "contactType": "customer support",
        "availableLanguage": ["Arabic", "English"]
      }
    };

    return {
      htmlAttrs: {
        lang: currentLocale === 'ar' ? 'ar' : 'en',
        dir: currentLocale === 'ar' ? 'rtl' : 'ltr'
      },
      __dangerouslyDisableSanitizers: ["script"],
      link: alternateLinks,
      meta: [
        // Open Graph locale tags
        {
          property: 'og:locale',
          content: currentLocale === 'ar' ? 'ar_AR' : 'en_US',
          hid: 'og:locale'
        },
        {
          property: 'og:locale:alternate',
          content: currentLocale === 'ar' ? 'en_US' : 'ar_AR',
          hid: 'og:locale:alternate'
        },
        {
          property: 'og:url',
          content: `${baseUrl}${currentPath}`,
          hid: 'og:url'
        }
      ],
      script: [
        {
          hid: "organization-schema",
          type: "application/ld+json",
          innerHTML: JSON.stringify(organizationSchema),
        },
      ]
    };
  },
  mounted: function () {
    const preloader = document.getElementById("preloader");
    if (preloader !== null || undefined) {
      preloader.remove();
    }
    // RTL initial
    const rtlURL = document.location.pathname.split("/")[1] === "ar";
    this.$vuetify.rtl = rtlURL;
  }
};
</script>

<style lang="scss">
:root {
  --contact-primary: #3f51b5;
  --contact-secondary: #f44336;
}

.global-brand-bg {
  min-height: 100vh;
  background:
    radial-gradient(circle at 2% 4%, rgba(63, 81, 181, 0.1), transparent 34%),
    radial-gradient(circle at 97% 8%, rgba(244, 67, 54, 0.08), transparent 30%),
    linear-gradient(180deg, #f8f9fd 0%, #f3f6fb 100%);
}
</style>
